/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { AxiosPromise } from "axios";
import * as bcrypt from "bcryptjs";
import {
  AdminUserCreate,
  AdminUserUpdate,
  CompanyProperties,
  CompanyTokenType,
  CompanyTransportOptionProperties,
  CompanyTransportOptionWithoutId,
  CompanyWithoutId,
  DefaultApiFactory,
  DoorProperties,
  DoorWithoutId,
  FavoriteUserWithoutId,
  InlineObject,
  InlineObject1,
  InlineObject10,
  InlineObject13,
  InlineObject14,
  InlineObject15,
  InlineObject17,
  InlineObject18,
  InlineObject19,
  InlineObject2,
  InlineObject20,
  InlineObject21,
  InlineObject3,
  InlineObject4,
  InlineObject5,
  InlineObject6,
  InlineObject8,
  InlineObject9,
  InlineResponse200,
  InlineResponse2001,
  InlineResponse20010,
  InlineResponse20011,
  InlineResponse20012,
  InlineResponse20013,
  InlineResponse20014,
  InlineResponse20015,
  InlineResponse20016,
  InlineResponse20017,
  InlineResponse20018,
  InlineResponse20019,
  InlineResponse2002,
  InlineResponse20020,
  InlineResponse20021,
  InlineResponse20022,
  InlineResponse20023,
  InlineResponse20024,
  InlineResponse20025,
  InlineResponse20026,
  InlineResponse20027,
  InlineResponse20028,
  InlineResponse20029,
  InlineResponse2003,
  InlineResponse20030,
  InlineResponse20031,
  InlineResponse20032,
  InlineResponse20033,
  InlineResponse20034,
  InlineResponse20035,
  InlineResponse20036,
  InlineResponse20037,
  InlineResponse20038,
  InlineResponse20039,
  InlineResponse2004,
  InlineResponse20040,
  InlineResponse20041,
  InlineResponse20042,
  InlineResponse20043,
  InlineResponse20044,
  InlineResponse20045,
  InlineResponse20046,
  InlineResponse20047,
  InlineResponse20048,
  InlineResponse20049,
  InlineResponse2005,
  InlineResponse20050,
  InlineResponse20051,
  InlineResponse20052,
  InlineResponse20053,
  InlineResponse20054,
  InlineResponse20055,
  InlineResponse20056,
  InlineResponse20057,
  InlineResponse20058,
  InlineResponse20059,
  InlineResponse2006,
  InlineResponse20060,
  InlineResponse20061,
  InlineResponse20062,
  InlineResponse20063,
  InlineResponse20064,
  InlineResponse20065,
  InlineResponse20066,
  InlineResponse20067,
  InlineResponse20068,
  InlineResponse20069,
  InlineResponse2007,
  InlineResponse20070,
  InlineResponse20071,
  InlineResponse20072,
  InlineResponse20073,
  InlineResponse20074,
  InlineResponse2008,
  InlineResponse2009,
  InlineResponse201,
  Language,
  LocationHours,
  LocationProperties,
  LocationWithoutId,
  MapObjectProperties,
  MapObjectWithoutId,
  MapProperties,
  MapWithoutId,
  MeAdmin,
  OAuthPasswordGrantResponse,
  ReportReasonProperties,
  ReportReasonWithoutId,
  ReservationAdd,
  ReservationCanCreate,
  ReservationStatus,
  ReservationType,
  ReservationUpdate,
  ReservationUpdateReoccurring,
  ResourceProperties,
  ResourceReservationProperties,
  ResourceWithoutId,
  SeatTagProperties,
  SeatTagWithoutId,
  SeatType,
  SeatUpdate,
  SeatWithoutId,
  TimeslotProperties,
  TimeslotWithoutId,
  UserCreate,
  UserGroupProperties,
  UserGroupWithoutId,
  UserStatus,
  UserUpdate,
  V2MeUser,
} from "../../bookmydesk-api-sdk-typescript-axios";
import { getRealClient } from "../src/hooks/useClient";
import { kSeatTags } from "./fake-data-new/seat-tags";
import { kUserGroups } from "./fake-data-new/user-groups";
import { kReservations } from "./fake-data-new/reservations";
import { kUsers } from "./fake-data-new/users";
import { kSeats } from "./fake-data-new/seats";
import { kAdminUser, kMeAdmin } from "./fake-data-new/admin-user";
import { kCompany } from "./fake-data-new/company";
import { kAdminUsers } from "./fake-data-new/admin-users";
import { kLocations } from "./fake-data-new/locations";
import { kMaps } from "./fake-data-new/maps";
import { kTimeslots } from "./fake-data-new/time-slots";
import { kAnalytics, kAnalyticsForLocation } from "./fake-data-new/analytics";
import { kTransportOptions } from "./fake-data-new/transport-options";
import { kReportReasons } from "./fake-data-new/report-reasons";
import { kReports } from "./fake-data-new/reports";
import { kResources } from "./fake-data-new/resources";
import { kResourceReservations } from "./fake-data-new/resource-reservations";
import {
  kReservationsStatistics_Desk,
  kReservationsStatistics_Lunch,
  kReservationsStatistics_Meeting,
} from "./fake-data-new/reservations-statistics";
import { kReservationsStatisticsToday } from "./fake-data-new/reservations-statistics-today";
import { kMapObjects } from "./fake-data-new/map-objects";
import { kMapImageUrls } from "./fake-data-new/map-image-urls";
import { kSeatsUsage } from "./fake-data-new/seats-usage";

export const shouldUseFakeClient = true;

const kUsername = "asael@demo.workplaced.com";
const kPassword =
  "$2b$10$BYVJJq6IPYZnhR8CfV.fcusmzrVLcwSVaaZ1RztljnF03b4EWe87e";

const kRefreshToken =
  "R4fsSOxCuQJ1eCodiOTa3Z77Nwx1NmyKawjWmqrRNWYKPyb2lXwi3glI1qmiOJsl1zkya0wXuEtBZYzC";
const kAccessToken =
  "J2gaxyAjieo4TEYPWQM9OxCUJctUwj7Wsxvp7cN8o3UXcWGWMqYRczAkBr8HWpg7lNQAO1KtEWTX0aa5";

const kResponseMeta = {
  status: 200,
  took: 0.044572167,
};

const respond = <T>(fnName: string, data: T): AxiosPromise<T> => {
  console.log(`fake client - ${fnName} - success`);

  return Promise.resolve({
    data: data,
    status: 200,
    statusText: "OK",
    headers: {},
    config: {},
  });
};

export const fakeClient: ReturnType<typeof DefaultApiFactory> = {
  /**
   * Verify the SAML response and redirect to frontend url with OTP
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  acsPost(options?: any): AxiosPromise<void> {
    return getRealClient(kAccessToken).acsPost(options);
  },
  /**
   *
   * @param {AdminUserCreate} adminUserCreate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  addAdminUser(
    adminUserCreate: AdminUserCreate,
    options?: any
  ): AxiosPromise<InlineResponse20022> {
    return getRealClient(kAccessToken).addAdminUser(adminUserCreate, options);
  },
  /**
   *
   * @param {CompanyWithoutId} companyWithoutId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  addCompany(
    companyWithoutId: CompanyWithoutId,
    options?: any
  ): AxiosPromise<InlineResponse20011> {
    return getRealClient(kAccessToken).addCompany(companyWithoutId, options);
  },
  /**
   *
   * @param {CompanyTransportOptionWithoutId} companyTransportOptionWithoutId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  addCompanyTransportOption(
    companyTransportOptionWithoutId: CompanyTransportOptionWithoutId,
    options?: any
  ): AxiosPromise<InlineResponse20071> {
    return getRealClient(kAccessToken).addCompanyTransportOption(
      companyTransportOptionWithoutId,
      options
    );
  },
  /**
   *
   * @param {DoorWithoutId} doorWithoutId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  addDoor(
    doorWithoutId: DoorWithoutId,
    options?: any
  ): AxiosPromise<InlineResponse20032> {
    return getRealClient(kAccessToken).addDoor(doorWithoutId, options);
  },
  /**
   * Add a favorite user
   * @param {FavoriteUserWithoutId} favoriteUserWithoutId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  addFavoriteUser(
    favoriteUserWithoutId: FavoriteUserWithoutId,
    options?: any
  ): AxiosPromise<void> {
    return getRealClient(kAccessToken).addFavoriteUser(
      favoriteUserWithoutId,
      options
    );
  },
  /**
   *
   * @param {LocationWithoutId} locationWithoutId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  addLocation(
    locationWithoutId: LocationWithoutId,
    options?: any
  ): AxiosPromise<InlineResponse20029> {
    return getRealClient(kAccessToken).addLocation(locationWithoutId, options);
  },
  /**
   *
   * @param {MapWithoutId} mapWithoutId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  addMap(
    mapWithoutId: MapWithoutId,
    options?: any
  ): AxiosPromise<InlineResponse2007> {
    return getRealClient(kAccessToken).addMap(mapWithoutId, options);
  },
  /**
   *
   * @param {string} mapId Map ID
   * @param {any} file
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  addMapFile(mapId: string, file: any, options?: any): AxiosPromise<void> {
    return getRealClient(kAccessToken).addMapFile(mapId, file, options);
  },
  /**
   *
   * @param {MapObjectWithoutId} mapObjectWithoutId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  addMapObject(
    mapObjectWithoutId: MapObjectWithoutId,
    options?: any
  ): AxiosPromise<InlineResponse20042> {
    return getRealClient(kAccessToken).addMapObject(
      mapObjectWithoutId,
      options
    );
  },
  /**
   *
   * @param {string} mapId Map ID
   * @param {any} file
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  addOriginalMapFile(
    mapId: string,
    file: any,
    options?: any
  ): AxiosPromise<void> {
    return getRealClient(kAccessToken).addOriginalMapFile(mapId, file, options);
  },
  /**
   *
   * @param {any} file
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  addProfileImage(file: any, options?: any): AxiosPromise<InlineResponse20070> {
    return getRealClient(kAccessToken).addProfileImage(file, options);
  },
  /**
   *
   * @param {ReportReasonWithoutId} reportReasonWithoutId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  addReportReason(
    reportReasonWithoutId: ReportReasonWithoutId,
    options?: any
  ): AxiosPromise<InlineResponse20017> {
    return getRealClient(kAccessToken).addReportReason(
      reportReasonWithoutId,
      options
    );
  },
  /**
   *
   * @param {ReservationAdd} reservationAdd
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  addReservation(
    reservationAdd: ReservationAdd,
    options?: any
  ): AxiosPromise<InlineResponse20059> {
    return getRealClient(kAccessToken).addReservation(reservationAdd, options);
  },
  /**
   *
   * @param {ResourceWithoutId} resourceWithoutId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  addResource(
    resourceWithoutId: ResourceWithoutId,
    options?: any
  ): AxiosPromise<InlineResponse20035> {
    return getRealClient(kAccessToken).addResource(resourceWithoutId, options);
  },
  /**
   *
   * @param {UNKNOWN_BASE_TYPE} uNKNOWNBASETYPE
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  addResourceReservation(
    uNKNOWNBASETYPE: any,
    options?: any
  ): AxiosPromise<InlineResponse20038> {
    return getRealClient(kAccessToken).addResourceReservation(
      uNKNOWNBASETYPE,
      options
    );
  },
  /**
   *
   * @param {SeatWithoutId} seatWithoutId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  addSeat(
    seatWithoutId: SeatWithoutId,
    options?: any
  ): AxiosPromise<InlineResponse20047> {
    return getRealClient(kAccessToken).addSeat(seatWithoutId, options);
  },
  /**
   *
   * @param {SeatTagWithoutId} seatTagWithoutId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  addSeatTag(
    seatTagWithoutId: SeatTagWithoutId,
    options?: any
  ): AxiosPromise<InlineResponse20050> {
    return getRealClient(kAccessToken).addSeatTag(seatTagWithoutId, options);
  },
  /**
   *
   * @param {TimeslotWithoutId} timeslotWithoutId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  addTimeslot(
    timeslotWithoutId: TimeslotWithoutId,
    options?: any
  ): AxiosPromise<InlineResponse20056> {
    return getRealClient(kAccessToken).addTimeslot(timeslotWithoutId, options);
  },
  /**
   *
   * @param {UserCreate} userCreate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  addUser(
    userCreate: UserCreate,
    options?: any
  ): AxiosPromise<InlineResponse20026> {
    return getRealClient(kAccessToken).addUser(userCreate, options);
  },
  /**
   *
   * @param {UserGroupWithoutId} userGroupWithoutId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  addUserGroup(
    userGroupWithoutId: UserGroupWithoutId,
    options?: any
  ): AxiosPromise<InlineResponse20053> {
    return getRealClient(kAccessToken).addUserGroup(
      userGroupWithoutId,
      options
    );
  },
  /**
   * Endpoint to test if a reservation with the provided properties is allowed to be created
   * @param {ReservationCanCreate} reservationCanCreate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  canCreateReservation(
    reservationCanCreate: ReservationCanCreate,
    options?: any
  ): AxiosPromise<InlineResponse20060> {
    return getRealClient(kAccessToken).canCreateReservation(
      reservationCanCreate,
      options
    );
  },
  /**
   * Endpoint to test if a reservation with the provided properties is allowed to be updated
   * @param {string} reservationId Reservation ID
   * @param {ReservationUpdate} reservationUpdate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  canUpdateReservation(
    reservationId: string,
    reservationUpdate: ReservationUpdate,
    options?: any
  ): AxiosPromise<InlineResponse20060> {
    return getRealClient(kAccessToken).canUpdateReservation(
      reservationId,
      reservationUpdate,
      options
    );
  },
  /**
   *
   * @param {InlineObject20} inlineObject20
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  cancelReservation(
    inlineObject20: InlineObject20,
    options?: any
  ): AxiosPromise<void> {
    return getRealClient(kAccessToken).cancelReservation(
      inlineObject20,
      options
    );
  },
  /**
   *
   * @param {string} locationId Location ID
   * @param {InlineObject17} inlineObject17
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  changeLocationOrder(
    locationId: string,
    inlineObject17: InlineObject17,
    options?: any
  ): AxiosPromise<InlineResponse20029> {
    return getRealClient(kAccessToken).changeLocationOrder(
      locationId,
      inlineObject17,
      options
    );
  },
  /**
   *
   * @param {string} mapId Map ID
   * @param {InlineObject13} inlineObject13
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  changeMapOrder(
    mapId: string,
    inlineObject13: InlineObject13,
    options?: any
  ): AxiosPromise<InlineResponse2007> {
    const map = kMaps.find((m) => m.id == mapId);
    return respond<InlineResponse2007>("changeMapOrder", {
      meta: kResponseMeta,
      result: {
        map: map,
      },
    });
  },
  /**
   *
   * @param {number} userId User ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteAdminUser(userId: number, options?: any): AxiosPromise<void> {
    return getRealClient(kAccessToken).deleteAdminUser(userId, options);
  },
  /**
   *
   * @param {string} companyId Company ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteCompany(companyId: string, options?: any): AxiosPromise<void> {
    return getRealClient(kAccessToken).deleteCompany(companyId, options);
  },
  /**
   *
   * @param {string} id CompanyTransportOption ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteCompanyTransportOption(id: string, options?: any): AxiosPromise<void> {
    return getRealClient(kAccessToken).deleteCompanyTransportOption(
      id,
      options
    );
  },
  /**
   *
   * @param {string} doorId Door ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteDoor(doorId: string, options?: any): AxiosPromise<void> {
    return getRealClient(kAccessToken).deleteDoor(doorId, options);
  },
  /**
   *
   * @param {string} id ExportFile ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteExportFile(id: string, options?: any): AxiosPromise<void> {
    return getRealClient(kAccessToken).deleteExportFile(id, options);
  },
  /**
   * Remove a favorite user
   * @param {string} favoriteUserId ID of the other user to remove from favorites
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteFavoriteUser(
    favoriteUserId: string,
    options?: any
  ): AxiosPromise<void> {
    return getRealClient(kAccessToken).deleteFavoriteUser(
      favoriteUserId,
      options
    );
  },
  /**
   *
   * @param {string} locationId Location ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteLocation(locationId: string, options?: any): AxiosPromise<void> {
    return getRealClient(kAccessToken).deleteLocation(locationId, options);
  },
  /**
   *
   * @param {string} locationId Location ID
   * @param {string} exceptionId Exception ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteLocationHours(
    locationId: string,
    exceptionId: string,
    options?: any
  ): AxiosPromise<InlineResponse20029> {
    return getRealClient(kAccessToken).deleteLocationHours(
      locationId,
      exceptionId,
      options
    );
  },
  /**
   *
   * @param {string} mapId Map ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteMap(mapId: string, options?: any): AxiosPromise<void> {
    return getRealClient(kAccessToken).deleteMap(mapId, options);
  },
  /**
   *
   * @param {string} mapObjectId MapObject ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteMapObject(mapObjectId: string, options?: any): AxiosPromise<void> {
    return getRealClient(kAccessToken).deleteMapObject(mapObjectId, options);
  },
  /**
   * Delete all future reservations with the same reoccurReferenceId
   * @param {string} reoccurReferenceId Reoccur reference ID
   * @param {string} [fromReservationId] Delete this reservation and all future reservations from this date with the same reoccurReferenceId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteReoccurringReservation(
    reoccurReferenceId: string,
    fromReservationId?: string,
    options?: any
  ): AxiosPromise<void> {
    return getRealClient(kAccessToken).deleteReoccurringReservation(
      reoccurReferenceId,
      fromReservationId,
      options
    );
  },
  /**
   *
   * @param {string} reportId Report ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteReport(reportId: string, options?: any): AxiosPromise<void> {
    return getRealClient(kAccessToken).deleteReport(reportId, options);
  },
  /**
   *
   * @param {string} reportReasonId Report reason ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteReportReason(
    reportReasonId: string,
    options?: any
  ): AxiosPromise<void> {
    return getRealClient(kAccessToken).deleteReportReason(
      reportReasonId,
      options
    );
  },
  /**
   *
   * @param {string} reservationId Reservation ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteReservation(reservationId: string, options?: any): AxiosPromise<void> {
    return getRealClient(kAccessToken).deleteReservation(
      reservationId,
      options
    );
  },
  /**
   * Delete Reservation
   * @summary Delete Reservation
   * @param {string} reservationId Reservation to delete
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteReservationForApp(
    reservationId: string,
    options?: any
  ): AxiosPromise<string> {
    return getRealClient(kAccessToken).deleteReservationForApp(
      reservationId,
      options
    );
  },
  /**
   *
   * @param {string} resourceId Resource ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteResource(resourceId: string, options?: any): AxiosPromise<void> {
    return getRealClient(kAccessToken).deleteResource(resourceId, options);
  },
  /**
   *
   * @param {string} resourceReservationId Resource Reservation ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteResourceReservation(
    resourceReservationId: string,
    options?: any
  ): AxiosPromise<void> {
    return getRealClient(kAccessToken).deleteResourceReservation(
      resourceReservationId,
      options
    );
  },
  /**
   *
   * @param {string} seatId Seat ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteSeat(seatId: string, options?: any): AxiosPromise<void> {
    return getRealClient(kAccessToken).deleteSeat(seatId, options);
  },
  /**
   *
   * @param {string} tagId Tag ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteSeatTag(tagId: string, options?: any): AxiosPromise<void> {
    return getRealClient(kAccessToken).deleteSeatTag(tagId, options);
  },
  /**
   *
   * @param {string} timeslotId Timeslot ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteTimeslot(timeslotId: string, options?: any): AxiosPromise<void> {
    return getRealClient(kAccessToken).deleteTimeslot(timeslotId, options);
  },
  /**
   *
   * @param {string} userId User ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteUser(userId: string, options?: any): AxiosPromise<void> {
    return getRealClient(kAccessToken).deleteUser(userId, options);
  },
  /**
   *
   * @param {string} groupId Group ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteUserGroup(groupId: string, options?: any): AxiosPromise<void> {
    return getRealClient(kAccessToken).deleteUserGroup(groupId, options);
  },
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  exportAdminUserEmails(options?: any): AxiosPromise<any> {
    return getRealClient(kAccessToken).exportAdminUserEmails(options);
  },
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  exportCompanyUserCount(options?: any): AxiosPromise<any> {
    return getRealClient(kAccessToken).exportCompanyUserCount(options);
  },
  /**
   *
   * @param {string} companyId Company ID
   * @param {'date' | 'from' | 'to' | 'cancelled' | 'includeParking' | 'visitorName' | 'visitorEmail' | 'visitorPhone' | 'user.firstName' | 'user.lastName' | 'user.email' | 'location.name' | 'map.name' | 'seat.name' | 'type'} [sortField] field to sort on
   * @param {'asc' | 'desc'} [sortDirection] direction to sort to
   * @param {string} [filter] value to filter with
   * @param {'equals' | 'not' | 'gt' | 'gte' | 'lt' | 'lte'} [fromOperator] Operator to apply to the \&#39;from\&#39; field
   * @param {number} [take] Amount of items to take
   * @param {number} [skip] Amount of items to skip
   * @param {string} [from] Start of daterange
   * @param {string} [to] End of daterange
   * @param {string} [userId] User ID
   * @param {ReservationStatus} [status] ReservationStatus
   * @param {string} [locationId] ReservationLocationId
   * @param {string} [mapId] ReservationMapId
   * @param {SeatType} [seatType] ReservationSeatType
   * @param {ReservationType} [type] ReservationType
   * @param {boolean} [includeAnonymous] includeAnonymous in reservations
   * @param {string} [companyTransportId] Filter reservations by company transport
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  exportReservations(
    companyId: string,
    sortField?:
      | "date"
      | "from"
      | "to"
      | "cancelled"
      | "includeParking"
      | "visitorName"
      | "visitorEmail"
      | "visitorPhone"
      | "user.firstName"
      | "user.lastName"
      | "user.email"
      | "location.name"
      | "map.name"
      | "seat.name"
      | "type",
    sortDirection?: "asc" | "desc",
    filter?: string,
    fromOperator?: "equals" | "not" | "gt" | "gte" | "lt" | "lte",
    take?: number,
    skip?: number,
    from?: string,
    to?: string,
    userId?: string,
    status?: ReservationStatus,
    locationId?: string,
    mapId?: string,
    seatType?: SeatType,
    type?: ReservationType,
    includeAnonymous?: boolean,
    companyTransportId?: string,
    options?: any
  ): AxiosPromise<any> {
    return getRealClient(kAccessToken).exportReservations(
      companyId,
      sortField,
      sortDirection,
      filter,
      fromOperator,
      take,
      skip,
      from,
      to,
      userId,
      status,
      locationId,
      mapId,
      seatType,
      type,
      includeAnonymous,
      companyTransportId,
      options
    );
  },
  /**
   * throw api error
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  failGet(options?: any): AxiosPromise<void> {
    return getRealClient(kAccessToken).failGet(options);
  },
  /**
   *
   * @param {number} userId User ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getAdminUser(
    userId: number,
    options?: any
  ): AxiosPromise<InlineResponse20021> {
    const user = kAdminUsers.find((u) => u.id === Number(userId));
    return respond<InlineResponse20021>("getAdminUser", {
      meta: kResponseMeta,
      result: {
        adminUser: user!,
      },
    });
  },
  /**
   *
   * @param {string} companyId Company ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getAnalytics(
    companyId: string,
    options?: any
  ): AxiosPromise<InlineResponse20074> {
    return respond<InlineResponse20074>("getAnalytics", {
      meta: kResponseMeta,
      result: kAnalytics,
    });
  },
  /**
   *
   * @param {string} locationId Location ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getAnalyticsForLocation(
    locationId: string,
    options?: any
  ): AxiosPromise<InlineResponse20074> {
    return respond<InlineResponse20074>("getAnalyticsForLocation", {
      meta: kResponseMeta,
      result: kAnalyticsForLocation,
    });
  },
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getBookMyDeskStatistics(options?: any): AxiosPromise<InlineResponse20067> {
    return getRealClient(kAccessToken).getBookMyDeskStatistics(options);
  },
  /**
   *
   * @param {string} companyId Company ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getCompany(
    companyId: string,
    options?: any
  ): AxiosPromise<InlineResponse20010> {
    return respond<InlineResponse20010>("getCompany", {
      meta: kResponseMeta,
      result: {
        company: kCompany,
      },
    });
  },
  /**
   *
   * @param {string} companyId Company ID to get
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getCompany4App(companyId: string, options?: any): AxiosPromise<object> {
    return getRealClient(kAccessToken).getCompany4App(companyId, options);
  },
  /**
   *
   * @param {string} companyId Company ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getCompanyExtended(
    companyId: string,
    options?: any
  ): AxiosPromise<InlineResponse2009> {
    return getRealClient(kAccessToken).getCompanyExtended(companyId, options);
  },
  /**
   *
   * @param {string} companyId Company ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getCompanyMSGroup(
    companyId: string,
    options?: any
  ): AxiosPromise<InlineResponse20012> {
    return getRealClient(kAccessToken).getCompanyMSGroup(companyId, options);
  },
  /**
   *
   * @param {string} companyId Company ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getCompanyMSGroupAvailable(
    companyId: string,
    options?: any
  ): AxiosPromise<InlineResponse20013> {
    return getRealClient(kAccessToken).getCompanyMSGroupAvailable(
      companyId,
      options
    );
  },
  /**
   * Get my reservations Company
   * @summary Get reservations for Company
   * @param {string} companyId Company ID to get reservations for
   * @param {string} [from] Start of daterange
   * @param {string} [to] End of daterange
   * @param {string} [locationId] LocationId to get reservations for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getCompanyReservations(
    companyId: string,
    from?: string,
    to?: string,
    locationId?: string,
    options?: any
  ): AxiosPromise<Array<object>> {
    return getRealClient(kAccessToken).getCompanyReservations(
      companyId,
      from,
      to,
      locationId,
      options
    );
  },
  /**
   *
   * @param {string} id CompanyTransportOption ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getCompanyTransportOption(
    id: string,
    options?: any
  ): AxiosPromise<InlineResponse20071> {
    return getRealClient(kAccessToken).getCompanyTransportOption(id, options);
  },
  /**
   *
   * @param {string} companyId Company ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getCompanyTransportOptions(
    companyId: string,
    options?: any
  ): AxiosPromise<InlineResponse20072> {
    return respond<InlineResponse20072>("getCompanyTransportOptions", {
      meta: kResponseMeta,
      result: {
        items: kTransportOptions,
      },
    });
  },
  /**
   *
   * @param {string} companyId Company ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getDataExport(companyId: string, options?: any): AxiosPromise<object> {
    return getRealClient(kAccessToken).getDataExport(companyId, options);
  },
  /**
   *
   * @param {string} doorId Door ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getDoor(doorId: string, options?: any): AxiosPromise<InlineResponse20031> {
    return getRealClient(kAccessToken).getDoor(doorId, options);
  },
  /**
   *
   * @param {string} companyId Company ID
   * @param {'created'} [sortField] field to sort on
   * @param {'asc' | 'desc'} [sortDirection] direction to sort to
   * @param {number} [take] Amount of items to take
   * @param {number} [skip] Amount of items to skip
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getExportFiles(
    companyId: string,
    sortField?: "created",
    sortDirection?: "asc" | "desc",
    take?: number,
    skip?: number,
    options?: any
  ): AxiosPromise<InlineResponse20073> {
    return getRealClient(kAccessToken).getExportFiles(
      companyId,
      sortField,
      sortDirection,
      take,
      skip,
      options
    );
  },
  /**
   * Get me iCal
   * @param {string} icalUuid UUID of the ical
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getIcal(icalUuid: string, options?: any): AxiosPromise<InlineResponse20068> {
    return getRealClient(kAccessToken).getIcal(icalUuid, options);
  },
  /**
   *
   * @param {string} locationId Location ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getLocation(
    locationId: string,
    options?: any
  ): AxiosPromise<InlineResponse20028> {
    const location = kLocations.find((l) => l.id === locationId);
    return respond<InlineResponse20028>("getLocation", {
      meta: kResponseMeta,
      result: {
        location: location!,
      },
    });
  },
  /**
   * Get stats for location
   * @summary Get stats for location
   * @param {string} locationId Location ID to get stats for
   * @param {string} date Date to get stats for
   * @param {string} from Start time to get stats for
   * @param {string} to End of time range
   * @param {'desk' | 'lunch' | 'meeting'} [seatType] Deprecated, use seatStatistics instead
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getLocationStats(
    locationId: string,
    date: string,
    from: string,
    to: string,
    seatType?: "desk" | "lunch" | "meeting",
    options?: any
  ): AxiosPromise<object> {
    return getRealClient(kAccessToken).getLocationStats(
      locationId,
      date,
      from,
      to,
      seatType,
      options
    );
  },
  /**
   *
   * @param {string} mapId Map ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getMap(mapId: string, options?: any): AxiosPromise<InlineResponse2006> {
    const map = kMaps.find((m) => m.id === mapId);
    return respond<InlineResponse2006>("getMap", {
      meta: kResponseMeta,
      result: {
        map: map!,
      },
    });
  },
  /**
   *
   * @param {string} mapId Map ID to get
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getMapImage(mapId: string, options?: any): AxiosPromise<void> {
    return getRealClient(kAccessToken).getMapImage(mapId, options);
  },
  /**
   *
   * @param {string} mapId Map ID to get
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getMapImageUrl(mapId: string, options?: any): AxiosPromise<object> {
    return getRealClient(kAccessToken).getMapImageUrl(mapId, options);
  },
  /**
   *
   * @param {string} mapObjectId MapObject ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getMapObject(
    mapObjectId: string,
    options?: any
  ): AxiosPromise<InlineResponse20041> {
    return getRealClient(kAccessToken).getMapObject(mapObjectId, options);
  },
  /**
   * Get requestion user
   * @summary Get  user
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getMe(options?: any): AxiosPromise<V2MeUser | MeAdmin> {
    return respond<MeAdmin>("getMe", kMeAdmin);
  },
  /**
   * Get me user
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getMe_1(options?: any): AxiosPromise<InlineResponse20069> {
    return getRealClient(kAccessToken).getMe_1(options);
  },
  /**
   * Get my reservations user
   * @summary Get reservations for user
   * @param {string} [companyId] Company ID to get reservations for
   * @param {string} [from] Start of daterange
   * @param {string} [to] End of daterange
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getMyReservations(
    companyId?: string,
    from?: string,
    to?: string,
    options?: any
  ): AxiosPromise<Array<object>> {
    return getRealClient(kAccessToken).getMyReservations(
      companyId,
      from,
      to,
      options
    );
  },
  /**
   *
   * @param {string} mapId Map ID to get
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getOriginalMapImageUrl(
    mapId: string,
    options?: any
  ): AxiosPromise<InlineResponse2004> {
    const mapImageUrl = kMapImageUrls.find((m) => m.mapId === mapId);
    return respond<InlineResponse2004>("getOriginalMapImageUrl", {
      meta: kResponseMeta,
      result: {
        url: mapImageUrl!.url,
      },
    });
  },
  /**
   *
   * @param {string} reportId Report ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getReport(
    reportId: string,
    options?: any
  ): AxiosPromise<InlineResponse20019> {
    return getRealClient(kAccessToken).getReport(reportId, options);
  },
  /**
   *
   * @param {string} reportReasonId Report reason ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getReportReason(
    reportReasonId: string,
    options?: any
  ): AxiosPromise<InlineResponse20015> {
    const reportReason = kReportReasons.find((r) => r.id === reportReasonId);
    return respond<InlineResponse20015>("getReportReason", {
      meta: kResponseMeta,
      result: {
        reportReason: reportReason!,
      },
    });
  },
  /**
   *
   * @param {string} resourceId Resource ID
   * @param {string} [dateFrom] Start date for getting amount available of resources
   * @param {string} [dateTo] End date for getting amount available of resources
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getResource(
    resourceId: string,
    dateFrom?: string,
    dateTo?: string,
    options?: any
  ): AxiosPromise<InlineResponse20034> {
    const resource = kResources.find((r) => r.id === resourceId);
    return respond<InlineResponse20034>("getResource", {
      meta: kResponseMeta,
      result: {
        resource: resource!,
      },
    });
  },
  /**
   *
   * @param {string} resourceReservationId Resource Reservation ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getResourceReservation(
    resourceReservationId: string,
    options?: any
  ): AxiosPromise<InlineResponse20037> {
    return getRealClient(kAccessToken).getResourceReservation(
      resourceReservationId,
      options
    );
  },
  /**
   *
   * @param {string} [seatId] Seat ID
   * @param {string} [barcode] Barcode
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getSeat(
    seatId?: string,
    barcode?: string,
    options?: any
  ): AxiosPromise<InlineResponse20046> {
    return getRealClient(kAccessToken).getSeat(seatId, barcode, options);
  },
  /**
   *
   * @param {string} tagId Tag ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getSeatTag(tagId: string, options?: any): AxiosPromise<InlineResponse20049> {
    const seatTag = kSeatTags.find((st) => st.id === tagId);
    return respond<InlineResponse20049>("getSeatTag", {
      meta: kResponseMeta,
      result: {
        seatTag: seatTag!,
      },
    });
  },
  /**
   *
   * @param {string} companyId Company ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getSeatsAvailableMSRooms(
    companyId: string,
    options?: any
  ): AxiosPromise<InlineResponse20045> {
    return getRealClient(kAccessToken).getSeatsAvailableMSRooms(
      companyId,
      options
    );
  },
  /**
   *
   * @param {string} timeslotId Timeslot ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getTimeslot(
    timeslotId: string,
    options?: any
  ): AxiosPromise<InlineResponse20055> {
    const timeslot = kTimeslots.find((t) => t.id === timeslotId);
    return respond<InlineResponse20055>("getTimeslot", {
      meta: kResponseMeta,
      result: {
        timeslot: timeslot!,
      },
    });
  },
  /**
   *
   * @param {string} userId User ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getUser(userId: string, options?: any): AxiosPromise<InlineResponse20025> {
    const user = kUsers.find((u) => u.id === userId);
    return respond<InlineResponse20025>("getUser", {
      meta: kResponseMeta,
      result: {
        user: user!,
      },
    });
  },
  /**
   *
   * @param {string} groupId Group ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getUserGroup(
    groupId: string,
    options?: any
  ): AxiosPromise<InlineResponse20052> {
    const group = kUserGroups.find((g) => g.id === groupId);
    return respond<InlineResponse20052>("getUserGroup", {
      meta: kResponseMeta,
      result: {
        userGroup: group!,
      },
    });
  },
  /**
   * Check API health
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  healthGet(options?: any): AxiosPromise<void> {
    return getRealClient(kAccessToken).healthGet(options);
  },
  /**
   * Import users by uploading a CSV (; as delimiter) containing e-mail addresses in the first column, or with columns firstname;infix;lastName;email;userGroups (userGroups are the user group labels separated by a ,)
   * @param {string} companyId Company ID
   * @param {any} file
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  importUsers(
    companyId: string,
    file: any,
    options?: any
  ): AxiosPromise<InlineResponse201> {
    return getRealClient(kAccessToken).importUsers(companyId, file, options);
  },
  /**
   *
   * @param {'email'} [sortField] field to sort on
   * @param {string} [companyId] Company ID, required for company admin, optional for super admin
   * @param {'asc' | 'desc'} [sortDirection] direction to sort to
   * @param {string} [filter] value to filter with
   * @param {number} [take] Amount of items to take
   * @param {number} [skip] Amount of items to skip
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  listAdminUsers(
    sortField?: "email",
    companyId?: string,
    sortDirection?: "asc" | "desc",
    filter?: string,
    take?: number,
    skip?: number,
    options?: any
  ): AxiosPromise<InlineResponse20020> {
    return respond<InlineResponse20020>("listAdminUsers", {
      meta: kResponseMeta,
      result: {
        items: kAdminUsers,
        total: kAdminUsers.length,
      },
    });
  },
  /**
   *
   * @param {'name' | 'billingPricePerCustomer' | 'billingStartDate' | 'language' | 'created'} [sortField] field to sort on
   * @param {'asc' | 'desc'} [sortDirection] direction to sort to
   * @param {string} [filter] value to filter with
   * @param {number} [take] Amount of items to take
   * @param {number} [skip] Amount of items to skip
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  listCompanies(
    sortField?:
      | "name"
      | "billingPricePerCustomer"
      | "billingStartDate"
      | "language"
      | "created",
    sortDirection?: "asc" | "desc",
    filter?: string,
    take?: number,
    skip?: number,
    options?: any
  ): AxiosPromise<InlineResponse2008> {
    return getRealClient(kAccessToken).listCompanies(
      sortField,
      sortDirection,
      filter,
      take,
      skip,
      options
    );
  },
  /**
   *
   * @param {string} companyId Company ID
   * @param {number} [take] Amount of items to take
   * @param {number} [skip] Amount of items to skip
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  listDoors(
    companyId: string,
    take?: number,
    skip?: number,
    options?: any
  ): AxiosPromise<InlineResponse20030> {
    return getRealClient(kAccessToken).listDoors(
      companyId,
      take,
      skip,
      options
    );
  },
  /**
   *
   * @param {string} companyId Company ID
   * @param {number} [take] Amount of items to take
   * @param {number} [skip] Amount of items to skip
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  listLocations(
    companyId: string,
    take?: number,
    skip?: number,
    options?: any
  ): AxiosPromise<InlineResponse20027> {
    return respond<InlineResponse20027>("listLocations", {
      meta: kResponseMeta,
      result: {
        items: kLocations,
        total: kLocations.length,
      },
    });
  },
  /**
   *
   * @param {string} companyId Company ID
   * @param {string} [mapId] Map ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  listMapObjects(
    companyId: string,
    mapId?: string,
    options?: any
  ): AxiosPromise<InlineResponse20040> {
    const mapObjects = kMapObjects.filter((obj) => obj.mapId === mapId);
    return respond<InlineResponse20040>("listMapObjects", {
      meta: kResponseMeta,
      result: {
        items: mapObjects,
      },
    });
  },
  /**
   *
   * @param {string} companyId Company ID
   * @param {number} [take] Amount of items to take
   * @param {number} [skip] Amount of items to skip
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  listMaps(
    companyId: string,
    take?: number,
    skip?: number,
    options?: any
  ): AxiosPromise<InlineResponse2005> {
    return respond<InlineResponse2005>("listMaps", {
      meta: kResponseMeta,
      result: {
        items: kMaps,
        total: kMaps.length,
      },
    });
  },
  /**
   *
   * @param {string} companyId Company ID
   * @param {'reason'} [sortField] field to sort on
   * @param {'asc' | 'desc'} [sortDirection] direction to sort to
   * @param {number} [take] Amount of items to take
   * @param {number} [skip] Amount of items to skip
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  listReportReasons(
    companyId: string,
    sortField?: "reason",
    sortDirection?: "asc" | "desc",
    take?: number,
    skip?: number,
    options?: any
  ): AxiosPromise<InlineResponse20014> {
    return respond<InlineResponse20014>("listReportReasons", {
      meta: kResponseMeta,
      result: {
        items: kReportReasons,
        total: kReportReasons.length,
      },
    });
  },
  /**
   *
   * @param {string} companyId Company ID
   * @param {'details'} [sortField] field to sort on
   * @param {'asc' | 'desc'} [sortDirection] direction to sort to
   * @param {number} [take] Amount of items to take
   * @param {number} [skip] Amount of items to skip
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  listReports(
    companyId: string,
    sortField?: "details",
    sortDirection?: "asc" | "desc",
    take?: number,
    skip?: number,
    options?: any
  ): AxiosPromise<InlineResponse20018> {
    return respond<InlineResponse20018>("listReports", {
      meta: kResponseMeta,
      result: {
        items: kReports,
        total: kReports.length,
      },
    });
  },
  /**
   *
   * @param {string} companyId Company ID
   * @param {'date' | 'from' | 'to' | 'cancelled' | 'includeParking' | 'visitorName' | 'visitorEmail' | 'visitorPhone' | 'user.firstName' | 'user.lastName' | 'user.email' | 'location.name' | 'map.name' | 'seat.name' | 'type'} [sortField] field to sort on
   * @param {'asc' | 'desc'} [sortDirection] direction to sort to
   * @param {string} [filter] value to filter with
   * @param {'equals' | 'not' | 'gt' | 'gte' | 'lt' | 'lte'} [fromOperator] Operator to apply to the \&#39;from\&#39; field
   * @param {boolean} [allForCompany] Get all for company
   * @param {number} [take] Amount of items to take
   * @param {number} [skip] Amount of items to skip
   * @param {string} [from] Start of daterange
   * @param {string} [to] End of daterange
   * @param {string} [userId] User ID
   * @param {ReservationStatus} [status] ReservationStatus
   * @param {string} [locationId] ReservationLocationId
   * @param {string} [mapId] ReservationMapId
   * @param {SeatType} [seatType] ReservationSeatType
   * @param {ReservationType} [type] ReservationType
   * @param {boolean} [includeAnonymous] includeAnonymous in reservations
   * @param {string} [userGroupId] Filter reservations by user group
   * @param {string} [companyTransportId] Filter reservations by company transport
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  listReservations(
    companyId: string,
    sortField?:
      | "date"
      | "from"
      | "to"
      | "cancelled"
      | "includeParking"
      | "visitorName"
      | "visitorEmail"
      | "visitorPhone"
      | "user.firstName"
      | "user.lastName"
      | "user.email"
      | "location.name"
      | "map.name"
      | "seat.name"
      | "type",
    sortDirection?: "asc" | "desc",
    filter?: string,
    fromOperator?: "equals" | "not" | "gt" | "gte" | "lt" | "lte",
    allForCompany?: boolean,
    take?: number,
    skip?: number,
    from?: string,
    to?: string,
    userId?: string,
    status?: ReservationStatus,
    locationId?: string,
    mapId?: string,
    seatType?: SeatType,
    type?: ReservationType,
    includeAnonymous?: boolean,
    userGroupId?: string,
    companyTransportId?: string,
    options?: any
  ): AxiosPromise<InlineResponse20062> {
    return respond<InlineResponse20062>("listReservations", {
      meta: kResponseMeta,
      result: {
        items: kReservations,
        total: kReservations.length,
      },
    });
  },
  /**
   *
   * @param {string} companyId Company ID
   * @param {string} [filter] value to filter with
   * @param {'equals' | 'not' | 'gt' | 'gte' | 'lt' | 'lte'} [fromOperator] Operator to apply to the \&#39;from\&#39; field
   * @param {string} [from] Start of daterange
   * @param {string} [to] End of daterange
   * @param {boolean} [isRepeatReservationParam] Filter reservations by repeat reservation
   * @param {number} [take] Amount of items to take
   * @param {number} [skip] Amount of items to skip
   * @param {string} [dateFrom] Start date for getting amount available of resource
   * @param {string} [dateTo] End date for getting amount available of resource
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  listResourceReservations(
    companyId: string,
    filter?: string,
    fromOperator?: "equals" | "not" | "gt" | "gte" | "lt" | "lte",
    from?: string,
    to?: string,
    isRepeatReservationParam?: boolean,
    take?: number,
    skip?: number,
    dateFrom?: string,
    dateTo?: string,
    options?: any
  ): AxiosPromise<InlineResponse20036> {
    return respond<InlineResponse20036>("listResourceReservations", {
      meta: kResponseMeta,
      result: {
        items: kResourceReservations,
        total: kResourceReservations.length,
      },
    });
  },
  /**
   *
   * @param {string} companyId Company ID
   * @param {number} [take] Amount of items to take
   * @param {number} [skip] Amount of items to skip
   * @param {string} [dateFrom] Start date for getting amount available of resources
   * @param {string} [dateTo] End date for getting amount available of resources
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  listResources(
    companyId: string,
    take?: number,
    skip?: number,
    dateFrom?: string,
    dateTo?: string,
    options?: any
  ): AxiosPromise<InlineResponse20033> {
    return respond<InlineResponse20033>("listResources", {
      meta: kResponseMeta,
      result: {
        items: kResources.slice(skip, (skip ?? 0) + (take ?? 20)),
        total: kResources.length,
      },
    });
  },
  /**
   *
   * @param {string} companyId Company ID
   * @param {number} [take] Amount of items to take
   * @param {number} [skip] Amount of items to skip
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  listSaltolocks(
    companyId: string,
    take?: number,
    skip?: number,
    options?: any
  ): AxiosPromise<InlineResponse20039> {
    return getRealClient(kAccessToken).listSaltolocks(
      companyId,
      take,
      skip,
      options
    );
  },
  /**
   *
   * @param {string} companyId Company ID
   * @param {'label'} [sortField] field to sort on
   * @param {'asc' | 'desc'} [sortDirection] direction to sort to
   * @param {number} [take] Amount of items to take
   * @param {number} [skip] Amount of items to skip
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  listSeatTags(
    companyId: string,
    sortField?: "label",
    sortDirection?: "asc" | "desc",
    take?: number,
    skip?: number,
    options?: any
  ): AxiosPromise<InlineResponse20048> {
    return respond<InlineResponse20048>("listSeatTags", {
      meta: kResponseMeta,
      result: {
        items: kSeatTags,
        total: kSeatTags.length,
      },
    });
  },
  /**
   *
   * @param {string} companyId Company ID
   * @param {string} [mapId] Map ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  listSeats(
    companyId: string,
    mapId?: string,
    options?: any
  ): AxiosPromise<InlineResponse20043> {
    return respond<InlineResponse20043>("listSeats", {
      meta: kResponseMeta,
      result: {
        items: kSeats,
      },
    });
  },
  /**
   *
   * @param {string} companyId Company ID
   * @param {string} [mapId] Map ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  listSeatsUsage(
    companyId: string,
    mapId?: string,
    options?: any
  ): AxiosPromise<InlineResponse20044> {
    return respond<InlineResponse20044>("listSeatsUsage", {
      meta: kResponseMeta,
      result: {
        items: kSeatsUsage,
      },
    });
  },
  /**
   *
   * @param {string} companyId Company ID
   * @param {'name' | 'from' | 'to'} [sortField] field to sort on
   * @param {'asc' | 'desc'} [sortDirection] direction to sort to
   * @param {number} [take] Amount of items to take
   * @param {number} [skip] Amount of items to skip
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  listTimeslots(
    companyId: string,
    sortField?: "name" | "from" | "to",
    sortDirection?: "asc" | "desc",
    take?: number,
    skip?: number,
    options?: any
  ): AxiosPromise<InlineResponse20054> {
    return respond<InlineResponse20054>("listTimeslots", {
      meta: kResponseMeta,
      result: {
        items: kTimeslots,
        total: kTimeslots.length,
      },
    });
  },
  /**
   *
   * @param {string} companyId Company ID
   * @param {'label'} [sortField] field to sort on
   * @param {'asc' | 'desc'} [sortDirection] direction to sort to
   * @param {number} [take] Amount of items to take
   * @param {number} [skip] Amount of items to skip
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  listUserGroups(
    companyId: string,
    sortField?: "label",
    sortDirection?: "asc" | "desc",
    take?: number,
    skip?: number,
    options?: any
  ): AxiosPromise<InlineResponse20051> {
    return respond<InlineResponse20051>("listUserGroups", {
      meta: kResponseMeta,
      result: {
        items: kUserGroups,
        total: kUserGroups.length,
      },
    });
  },
  /**
   *
   * @param {string} companyId Company ID
   * @param {'firstName' | 'infix' | 'lastName' | 'email' | 'language' | 'status'} [sortField] field to sort on
   * @param {boolean} [inviteSent] filter on whether an invite has been sent
   * @param {UserStatus} [status] filter on status
   * @param {Language} [language] filter on language
   * @param {string} [userGroupId] filter on userGroup
   * @param {'asc' | 'desc'} [sortDirection] direction to sort to
   * @param {string} [filter] value to filter with
   * @param {number} [take] Amount of items to take
   * @param {number} [skip] Amount of items to skip
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  listUsers(
    companyId: string,
    sortField?:
      | "firstName"
      | "infix"
      | "lastName"
      | "email"
      | "language"
      | "status",
    inviteSent?: boolean,
    status?: UserStatus,
    language?: Language,
    userGroupId?: string,
    sortDirection?: "asc" | "desc",
    filter?: string,
    take?: number,
    skip?: number,
    options?: any
  ): AxiosPromise<InlineResponse20024> {
    return respond<InlineResponse20024>("listUsers", {
      meta: kResponseMeta,
      result: {
        items: kUsers.slice(skip, (skip ?? 0) + (take ?? 20)),
        total: kUsers.length,
      },
    });
  },
  /**
   *
   * @param {string} companyId Company ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  listUsersExport(companyId: string, options?: any): AxiosPromise<any> {
    return getRealClient(kAccessToken).listUsersExport(companyId, options);
  },
  /**
   *
   * @param {number} userId User ID
   * @param {string} clientId Client ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  loginAsAdminUser(
    userId: number,
    clientId: string,
    options?: any
  ): AxiosPromise<InlineResponse20023> {
    return getRealClient().loginAsAdminUser(userId, clientId, options);
  },
  /**
   * Logout user
   * @summary logout
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  logout(options?: any): AxiosPromise<string> {
    return getRealClient(kAccessToken).logout(options);
  },
  /**
   *
   * @param {string} [adminConsent] admin_consent from MS
   * @param {string} [state] State send in step one
   * @param {string} [tenant] Tennant of the admin user (company ID)
   * @param {string} [scope] Scope of the gotten access
   * @param {string} [error] MS error Code
   * @param {string} [errorDescription] error description by microsoft
   * @param {string} [errorUri] error description by microsoft
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  mSAdminCallback(
    adminConsent?: string,
    state?: string,
    tenant?: string,
    scope?: string,
    error?: string,
    errorDescription?: string,
    errorUri?: string,
    options?: any
  ): AxiosPromise<void> {
    return getRealClient(kAccessToken).mSAdminCallback(
      adminConsent,
      state,
      tenant,
      scope,
      error,
      errorDescription,
      errorUri,
      options
    );
  },
  /**
   *
   * @param {string} [code] Code from MS
   * @param {string} [state] State send in step one
   * @param {string} [sessionState] State of session - what is difference?
   * @param {string} [error] MS error Code
   * @param {string} [errorDescription] error description by microsoft
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  mSCallback(
    code?: string,
    state?: string,
    sessionState?: string,
    error?: string,
    errorDescription?: string,
    options?: any
  ): AxiosPromise<void> {
    return getRealClient(kAccessToken).mSCallback(
      code,
      state,
      sessionState,
      error,
      errorDescription,
      options
    );
  },
  /**
   * SAML2 metadata
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  metadataGet(options?: any): AxiosPromise<string> {
    return getRealClient(kAccessToken).metadataGet(options);
  },
  /**
   * Basic API metrics
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  metricsGet(options?: any): AxiosPromise<void> {
    return getRealClient(kAccessToken).metricsGet(options);
  },
  /**
   * oAuth routes, eg password grant or refresh
   * @summary Oauth password grant
   * @param {string} [clientId]
   * @param {string} [clientSecret]
   * @param {string} [refreshToken]
   * @param {string} [grantType]
   * @param {string} [username]
   * @param {string} [password]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  oAuthPasswordGrant(
    clientId?: string,
    clientSecret?: string,
    refreshToken?: string,
    grantType?: string,
    username?: string,
    password?: string,
    options?: any
  ): AxiosPromise<OAuthPasswordGrantResponse> {
    const authorize = async () => {
      if (grantType === "password") {
        if (username !== kUsername || typeof password !== "string") {
          return false;
        }

        return await bcrypt.compare(password, kPassword);
      } else if (grantType === "refresh_token") {
        return refreshToken === kRefreshToken;
      } else {
        return false;
      }
    };

    return authorize().then((isOk) => {
      if (isOk) {
        return respond<OAuthPasswordGrantResponse>("oAuthPasswordGrant", {
          access_token: kAccessToken,
          refresh_token: kRefreshToken,
          username: kAdminUser.email,
          token_type: "Bearer",
        });
      } else {
        return Promise.reject({
          response: {
            status: 403,
          },
        });
      }
    });
  },
  /**
   *
   * @param {string} doorId Door ID
   * @param {string} reservationId Reservation ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  openDoor(
    doorId: string,
    reservationId: string,
    options?: any
  ): AxiosPromise<InlineResponse20032> {
    return getRealClient(kAccessToken).openDoor(doorId, reservationId, options);
  },
  /**
   * Post new reservation
   * @summary Post new reservation
   * @param {string} companyId Company ID to create reservations for - not used by api but for backwards compatibility
   * @param {InlineObject8} [inlineObject8]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  postCompanyReservation(
    companyId: string,
    inlineObject8?: InlineObject8,
    options?: any
  ): AxiosPromise<InlineResponse2001> {
    return getRealClient(kAccessToken).postCompanyReservation(
      companyId,
      inlineObject8,
      options
    );
  },
  /**
   * Post new Reocurring reservation
   * @summary Post new Reocurring reservation
   * @param {string} companyId Company ID to create reservations for - not needed as queried via seat
   * @param {InlineObject10} [inlineObject10]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  postCompanyReservationReocurring(
    companyId: string,
    inlineObject10?: InlineObject10,
    options?: any
  ): AxiosPromise<InlineResponse2002> {
    return getRealClient(kAccessToken).postCompanyReservationReocurring(
      companyId,
      inlineObject10,
      options
    );
  },
  /**
   * Post device token
   * @summary post Device
   * @param {InlineObject3} inlineObject3
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  postDevice(
    inlineObject3: InlineObject3,
    options?: any
  ): AxiosPromise<string> {
    return getRealClient(kAccessToken).postDevice(inlineObject3, options);
  },
  /**
   * Post new report
   * @summary post report
   * @param {InlineObject4} inlineObject4
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  postReport(
    inlineObject4: InlineObject4,
    options?: any
  ): AxiosPromise<InlineResponse2001> {
    return getRealClient(kAccessToken).postReport(inlineObject4, options);
  },
  /**
   *
   * @param {string} clientId ClientId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  redirToMS(clientId: string, options?: any): AxiosPromise<void> {
    return getRealClient(kAccessToken).redirToMS(clientId, options);
  },
  /**
   *
   * @param {string} [type] Type
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  redirToMSAdmin(
    type?: string,
    options?: any
  ): AxiosPromise<InlineResponse20066> {
    return getRealClient(kAccessToken).redirToMSAdmin(type, options);
  },
  /**
   * Register a new company
   * @param {InlineObject5} inlineObject5
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  registerCompany(
    inlineObject5: InlineObject5,
    options?: any
  ): AxiosPromise<void> {
    return getRealClient(kAccessToken).registerCompany(inlineObject5, options);
  },
  /**
   *
   * @param {string} companyId Company ID
   * @param {CompanyTokenType} tokenType type of token
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  removeCompanyTokens(
    companyId: string,
    tokenType: CompanyTokenType,
    options?: any
  ): AxiosPromise<void> {
    return getRealClient(kAccessToken).removeCompanyTokens(
      companyId,
      tokenType,
      options
    );
  },
  /**
   * Request login by post\'ing email for user
   * @summary Request Login
   * @param {InlineObject} inlineObject
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  requestLogin(inlineObject: InlineObject, options?: any): AxiosPromise<void> {
    return getRealClient().requestLogin(inlineObject, options);
  },
  /**
   *
   * @param {string} reservationId Reservation ID to checkin for
   * @param {InlineObject18} [inlineObject18]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  reservationCheckIn(
    reservationId: string,
    inlineObject18?: InlineObject18,
    options?: any
  ): AxiosPromise<InlineResponse20057> {
    return getRealClient(kAccessToken).reservationCheckIn(
      reservationId,
      inlineObject18,
      options
    );
  },
  /**
   *
   * @param {string} reservationId Reservation ID to checkout for
   * @param {InlineObject19} [inlineObject19]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  reservationCheckout(
    reservationId: string,
    inlineObject19?: InlineObject19,
    options?: any
  ): AxiosPromise<void> {
    return getRealClient(kAccessToken).reservationCheckout(
      reservationId,
      inlineObject19,
      options
    );
  },
  /**
   *
   * @param {string} from date
   * @param {string} to date
   * @param {SeatType} seatType seat type
   * @param {string} companyId Company ID
   * @param {string} [locationId] location
   * @param {string} [mapId] map
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  reservationsStatistics(
    from: string,
    to: string,
    seatType: SeatType,
    companyId: string,
    locationId?: string,
    mapId?: string,
    options?: any
  ): AxiosPromise<InlineResponse20063> {
    const result = () => {
      switch (seatType) {
        case "desk":
          return kReservationsStatistics_Desk;
        case "lunch":
          return kReservationsStatistics_Lunch;
        case "meeting":
          return kReservationsStatistics_Meeting;
        default:
          throw new Error(`Unknown seat type: ${seatType}`);
      }
    };

    return respond<InlineResponse20063>("reservationsStatistics", {
      meta: kResponseMeta,
      result: result(),
    });
  },
  /**
   *
   * @param {string} companyId Company ID
   * @param {string} [locationId] location
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  reservationsStatisticsToday(
    companyId: string,
    locationId?: string,
    options?: any
  ): AxiosPromise<InlineResponse20065> {
    return respond<InlineResponse20065>("reservationsStatisticsToday", {
      meta: kResponseMeta,
      result: kReservationsStatisticsToday,
    });
  },
  /**
   * Reset user\'s password
   * @param {InlineObject1} inlineObject1
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  resetPassword(
    inlineObject1: InlineObject1,
    options?: any
  ): AxiosPromise<void> {
    return getRealClient(kAccessToken).resetPassword(inlineObject1, options);
  },
  /**
   * Redirect the browser to the SAML IDP
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  samlRedirectGet(options?: any): AxiosPromise<void> {
    return getRealClient(kAccessToken).samlRedirectGet(options);
  },
  /**
   * Send invitations to multiple users
   * @param {InlineObject15} inlineObject15
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  sendUsersInvitations(
    inlineObject15: InlineObject15,
    options?: any
  ): AxiosPromise<void> {
    return getRealClient(kAccessToken).sendUsersInvitations(
      inlineObject15,
      options
    );
  },
  /**
   *
   * @param {string} companyId Company ID
   * @param {string} [locationId] ReservationLocationId
   * @param {'desk' | 'lunch' | 'meeting'} [seatType] Seat type
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  statisticsToday(
    companyId: string,
    locationId?: string,
    seatType?: "desk" | "lunch" | "meeting",
    options?: any
  ): AxiosPromise<InlineResponse20064> {
    return getRealClient(kAccessToken).statisticsToday(
      companyId,
      locationId,
      seatType,
      options
    );
  },
  /**
   *
   * @param {number} userId User ID
   * @param {AdminUserUpdate} adminUserUpdate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateAdminUser(
    userId: number,
    adminUserUpdate: AdminUserUpdate,
    options?: any
  ): AxiosPromise<InlineResponse20022> {
    return getRealClient(kAccessToken).updateAdminUser(
      userId,
      adminUserUpdate,
      options
    );
  },
  /**
   *
   * @param {string} companyId Company ID
   * @param {CompanyProperties} companyProperties
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateCompany(
    companyId: string,
    companyProperties: CompanyProperties,
    options?: any
  ): AxiosPromise<InlineResponse20011> {
    return getRealClient(kAccessToken).updateCompany(
      companyId,
      companyProperties,
      options
    );
  },
  /**
   *
   * @param {string} companyId Company ID
   * @param {InlineObject14} inlineObject14
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateCompanyMSGroup(
    companyId: string,
    inlineObject14: InlineObject14,
    options?: any
  ): AxiosPromise<InlineResponse20012> {
    return getRealClient(kAccessToken).updateCompanyMSGroup(
      companyId,
      inlineObject14,
      options
    );
  },
  /**
   *
   * @param {string} id CompanyTransportOption ID
   * @param {CompanyTransportOptionProperties} companyTransportOptionProperties
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateCompanyTransportOption(
    id: string,
    companyTransportOptionProperties: CompanyTransportOptionProperties,
    options?: any
  ): AxiosPromise<InlineResponse20071> {
    return getRealClient(kAccessToken).updateCompanyTransportOption(
      id,
      companyTransportOptionProperties,
      options
    );
  },
  /**
   *
   * @param {string} doorId Door ID
   * @param {DoorProperties} doorProperties
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateDoor(
    doorId: string,
    doorProperties: DoorProperties,
    options?: any
  ): AxiosPromise<object> {
    return getRealClient(kAccessToken).updateDoor(
      doorId,
      doorProperties,
      options
    );
  },
  /**
   *
   * @param {string} locationId Location ID
   * @param {LocationProperties} locationProperties
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateLocation(
    locationId: string,
    locationProperties: LocationProperties,
    options?: any
  ): AxiosPromise<object> {
    return getRealClient(kAccessToken).updateLocation(
      locationId,
      locationProperties,
      options
    );
  },
  /**
   *
   * @param {string} locationId Location ID
   * @param {LocationHours} locationHours
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateLocationHours(
    locationId: string,
    locationHours: LocationHours,
    options?: any
  ): AxiosPromise<InlineResponse20029> {
    return getRealClient(kAccessToken).updateLocationHours(
      locationId,
      locationHours,
      options
    );
  },
  /**
   *
   * @param {string} mapId Map ID
   * @param {MapProperties} mapProperties
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateMap(
    mapId: string,
    mapProperties: MapProperties,
    options?: any
  ): AxiosPromise<InlineResponse2007> {
    return getRealClient(kAccessToken).updateMap(mapId, mapProperties, options);
  },
  /**
   *
   * @param {string} mapObjectId MapObject ID
   * @param {MapObjectProperties} mapObjectProperties
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateMapObject(
    mapObjectId: string,
    mapObjectProperties: MapObjectProperties,
    options?: any
  ): AxiosPromise<InlineResponse20042> {
    return getRealClient(kAccessToken).updateMapObject(
      mapObjectId,
      mapObjectProperties,
      options
    );
  },
  /**
   *
   * @param {InlineObject21} inlineObject21
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateMe(
    inlineObject21: InlineObject21,
    options?: any
  ): AxiosPromise<InlineResponse20070> {
    return getRealClient(kAccessToken).updateMe(inlineObject21, options);
  },
  /**
   * Update user\'s password
   * @param {InlineObject2} inlineObject2
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updatePassword(
    inlineObject2: InlineObject2,
    options?: any
  ): AxiosPromise<void> {
    return getRealClient(kAccessToken).updatePassword(inlineObject2, options);
  },
  /**
   * Update all future reservations with the same reoccurReferenceId
   * @param {string} reoccurReferenceId Reoccur reference ID
   * @param {ReservationUpdateReoccurring} reservationUpdateReoccurring
   * @param {string} [referenceId] Reference ID
   * @param {string} [fromReservationId] Update this reservation and all future reservations from this date with the same reoccurReferenceId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateReoccurringReservation(
    reoccurReferenceId: string,
    reservationUpdateReoccurring: ReservationUpdateReoccurring,
    referenceId?: string,
    fromReservationId?: string,
    options?: any
  ): AxiosPromise<InlineResponse20061> {
    return getRealClient(kAccessToken).updateReoccurringReservation(
      reoccurReferenceId,
      reservationUpdateReoccurring,
      referenceId,
      fromReservationId,
      options
    );
  },
  /**
   *
   * @param {string} reportReasonId Report reason ID
   * @param {ReportReasonProperties} reportReasonProperties
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateReportReason(
    reportReasonId: string,
    reportReasonProperties: ReportReasonProperties,
    options?: any
  ): AxiosPromise<InlineResponse20016> {
    return getRealClient(kAccessToken).updateReportReason(
      reportReasonId,
      reportReasonProperties,
      options
    );
  },
  /**
   * Update reservation
   * @summary Updatereservation
   * @param {string} reservationId reservation_id to update
   * @param {InlineObject9} [inlineObject9]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateReservation(
    reservationId: string,
    inlineObject9?: InlineObject9,
    options?: any
  ): AxiosPromise<void> {
    return getRealClient(kAccessToken).updateReservation(
      reservationId,
      inlineObject9,
      options
    );
  },
  /**
   *
   * @param {string} reservationId Reservation ID
   * @param {ReservationUpdate} reservationUpdate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateReservation_2(
    reservationId: string,
    reservationUpdate: ReservationUpdate,
    options?: any
  ): AxiosPromise<InlineResponse20058> {
    return getRealClient(kAccessToken).updateReservation_2(
      reservationId,
      reservationUpdate,
      options
    );
  },
  /**
   *
   * @param {string} resourceId Resource ID
   * @param {ResourceProperties} resourceProperties
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateResource(
    resourceId: string,
    resourceProperties: ResourceProperties,
    options?: any
  ): AxiosPromise<object> {
    return getRealClient(kAccessToken).updateResource(
      resourceId,
      resourceProperties,
      options
    );
  },
  /**
   *
   * @param {string} resourceReservationId Resource Reservation ID
   * @param {ResourceReservationProperties} resourceReservationProperties
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateResourceReservation(
    resourceReservationId: string,
    resourceReservationProperties: ResourceReservationProperties,
    options?: any
  ): AxiosPromise<object> {
    return getRealClient(kAccessToken).updateResourceReservation(
      resourceReservationId,
      resourceReservationProperties,
      options
    );
  },
  /**
   *
   * @param {string} seatId Seat ID
   * @param {SeatUpdate} seatUpdate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateSeat(
    seatId: string,
    seatUpdate: SeatUpdate,
    options?: any
  ): AxiosPromise<InlineResponse20047> {
    return getRealClient(kAccessToken).updateSeat(seatId, seatUpdate, options);
  },
  /**
   *
   * @param {string} tagId Tag ID
   * @param {SeatTagProperties} seatTagProperties
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateSeatTag(
    tagId: string,
    seatTagProperties: SeatTagProperties,
    options?: any
  ): AxiosPromise<InlineResponse20050> {
    return getRealClient(kAccessToken).updateSeatTag(
      tagId,
      seatTagProperties,
      options
    );
  },
  /**
   *
   * @param {string} timeslotId Timeslot ID
   * @param {TimeslotProperties} timeslotProperties
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateTimeslot(
    timeslotId: string,
    timeslotProperties: TimeslotProperties,
    options?: any
  ): AxiosPromise<InlineResponse20056> {
    return getRealClient(kAccessToken).updateTimeslot(
      timeslotId,
      timeslotProperties,
      options
    );
  },
  /**
   *
   * @param {string} userId User ID
   * @param {UserUpdate} userUpdate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateUser(
    userId: string,
    userUpdate: UserUpdate,
    options?: any
  ): AxiosPromise<InlineResponse20026> {
    return getRealClient(kAccessToken).updateUser(userId, userUpdate, options);
  },
  /**
   *
   * @param {string} groupId Group ID
   * @param {UserGroupProperties} userGroupProperties
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateUserGroup(
    groupId: string,
    userGroupProperties: UserGroupProperties,
    options?: any
  ): AxiosPromise<InlineResponse20053> {
    return getRealClient(kAccessToken).updateUserGroup(
      groupId,
      userGroupProperties,
      options
    );
  },
  /**
   *
   * @param {any} file
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  v2AddProfileImage(file: any, options?: any): AxiosPromise<void> {
    return getRealClient(kAccessToken).v2AddProfileImage(file, options);
  },
  /**
   *
   * @param {InlineObject6} inlineObject6
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  v2UpdateMe(
    inlineObject6: InlineObject6,
    options?: any
  ): AxiosPromise<string> {
    return getRealClient(kAccessToken).v2UpdateMe(inlineObject6, options);
  },
  /**
   * Copy of saml-redirect
   * @param {string} [clientId] Not needed, but exists in frontend
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  v3AuthSurfconextGet(clientId?: string, options?: any): AxiosPromise<void> {
    return getRealClient(kAccessToken).v3AuthSurfconextGet(clientId, options);
  },
  /**
   * Client compatibility
   * @param {string} clientId The oAuth client identifier
   * @param {string} version The current version of the client application
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  v3CompatibilityGet(
    clientId: string,
    version: string,
    options?: any
  ): AxiosPromise<InlineResponse2003> {
    return getRealClient(kAccessToken).v3CompatibilityGet(
      clientId,
      version,
      options
    );
  },
  /**
   *
   * @param {string} from date
   * @param {string} to date
   * @param {string} companyId Company ID
   * @param {string} [locationId] ReservationLocationId
   * @param {'desk' | 'lunch' | 'meeting'} [seatType] Seat type
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  v3Statistics(
    from: string,
    to: string,
    companyId: string,
    locationId?: string,
    seatType?: "desk" | "lunch" | "meeting",
    options?: any
  ): AxiosPromise<InlineResponse20064> {
    return getRealClient(kAccessToken).v3Statistics(
      from,
      to,
      companyId,
      locationId,
      seatType,
      options
    );
  },
  /**
   * API version
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  versionGet(options?: any): AxiosPromise<InlineResponse200> {
    return getRealClient(kAccessToken).versionGet(options);
  },
};
